export default __webpack_public_path__ + "static/products-fwfunctions-en-4348fe1a1a94611b9671366e04d69801.png";